interface SearchResult {
    id: string;
    systemId: string;
    textContent: string;
    selected: boolean;
    onClickHandler: (systemId: string) => void;
}

const ImpersonationBannerSearchResult = ({
    id,
    systemId,
    textContent,
    selected,
    onClickHandler
}: SearchResult) => {
    const selectOnEnterKey = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter' && !selected) {
            onClickHandler(systemId);
        }
    };

    return(
        <div
            data-result="person"
            className={`
                h-full w-full text-black py-2.5 px-2.5 border-b border-[#D5D3DE] 
                ${selected ? 'bg-slate-200 cursor-default' : 'hover:bg-slate-200 focus-within:bg-slate-200 cursor-pointer'}
            `}
            key={systemId}
            data-id={id}
            onClick={() => onClickHandler(systemId)}
            onKeyDown={selectOnEnterKey}
            tabIndex={!selected ? 0 : undefined}
        >
            {textContent}
        </div>
    )
}

export default ImpersonationBannerSearchResult;
